import React, { useState } from "react";
import styles from "./index.module.scss";
import Button from "../../UI/Button";
import { track } from "../../../utils/amplitude";

export default function Subscription() {
  const [success, setSuccesss] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const onSubmitHandler = (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    fetch("https://api.apphud.com/users/subscribe", {
      method: "POST",
      body: form,
    })
      .then(() => {
        setSuccesss(true);
        setTimeout(() => {
          setSuccesss(false);
        }, 3000);
        e.target?.reset();
      })
      .finally(() => {
        setDisabled(false);
      });
  };
  return (
    <div className={styles.container}>
      <div className={styles.flex1}>
        <label>Let's stay in touch!</label>
        <p>Get the latest updates and insights from Apphud.</p>
      </div>
      <form onSubmit={onSubmitHandler}>
        <div>
          <input
            type="email"
            name="email"
            className={styles.input}
            placeholder="Your Email..."
            required={true}
          />
        </div>
        <div>
          <Button
            onClick={() => {
              if (window?.dataLayer) {
                window?.dataLayer.push({ event: "blog_subscribe_submit" });
              }
              track("blog_subscribe");
            }}
            disabled={disabled || success}
            title={success ? "Subscribed" : "Subscribe"}
            className={styles.button}
            type="submit"
          />
        </div>
      </form>
    </div>
  );
}
